import React, { useState, useContext } from "react";
import AIFeedbackButton from "../AIFeedbackButton";
import TeacherFeedbackEditor from "../TeacherFeedbackEditor";
import formatFeedback from "./formatFeedback";
import { UserContext } from "../../../../../App";

const QuestionWrapper = ({
  children,
  material,
  moduleData,
  aiFeedback,
  practiceResults,
  onAIFeedbackRequest,
  isTeacher,
  isViewingAsStudent,
  studentResponses,
  onSaveFeedback,
  editingFeedback,
  onEditFeedback,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const { role } = useContext(UserContext);

  const handleAIFeedbackRequest = async (questionId) => {
    setIsLoading(true);
    await onAIFeedbackRequest(questionId);
    setIsLoading(false);
  };

  const renderAIFeedback = () => {
    const disabledGameTypes = ["The Guessinator", "Flashcards"];

    // Only allow AI feedback for plus roles and admin
    const canUseAIFeedback = [
      "studentplus",
      "teacherplus",
      "admin",
      "technicianplus",
    ].includes(role);

    // Show AI feedback for students or teachers in simulation mode (not viewing specific student)
    const shouldShowAIFeedback =
      !isTeacher || (isTeacher && !isViewingAsStudent);

    if (
      moduleData.isQuizMode ||
      !moduleData.AIChatEnabled ||
      !shouldShowAIFeedback ||
      studentResponses[material.questionId]?.grade?.feedback ||
      disabledGameTypes.includes(material.questionType) ||
      !canUseAIFeedback
    ) {
      return null;
    }

    return (
      <>
        {!aiFeedback[material.questionId] && (
          <AIFeedbackButton
            onClick={() => handleAIFeedbackRequest(material.questionId)}
            className="mt-2 ml-2"
            isLoading={isLoading}
            label={isTeacher ? "Get AI Feedback" : "Chat with AI"}
          />
        )}
        {aiFeedback[material.questionId] && (
          <div className="teacher-feedback">
            <div className="feedback-header">
              <h4>AI Feedback:</h4>
            </div>
            <div className="feedback-content-wrapper">
              <div className="feedback-content">
                <div className="ai-feedback-container">
                  <div className="ai-feedback-text">
                    <p
                      dangerouslySetInnerHTML={{
                        __html: formatFeedback.formatForDisplay(
                          aiFeedback[material.questionId]
                        ),
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </>
    );
  };

  const renderPracticeResults = () => {
    if (!practiceResults[material.questionId]) return null;

    return (
      <div
        className={`practice-result ${
          practiceResults[material.questionId].isCorrect
            ? "correct"
            : "incorrect"
        }`}
      >
        {practiceResults[material.questionId].explanation}
      </div>
    );
  };

  return (
    <>
      {children}
      {renderAIFeedback()}
      {renderPracticeResults()}
      {((isTeacher && isViewingAsStudent) || !isTeacher) &&
        !["The Guessinator", "Flashcards"].includes(material.questionType) && (
          <TeacherFeedbackEditor
            feedback={studentResponses[material.questionId]?.grade?.feedback}
            onSave={onSaveFeedback}
            questionId={material.questionId}
            isEditing={editingFeedback === material.questionId}
            onEditClick={onEditFeedback}
            onAIFeedbackRequest={onAIFeedbackRequest}
            aiFeedback={aiFeedback[material.questionId]}
            isTeacher={isTeacher}
            studentResponses={studentResponses}
            questionType={material.questionType}
          />
        )}
    </>
  );
};

export default QuestionWrapper;
